import { createUseStyles } from 'react-jss';

export const styles = createUseStyles({
  container: {
    left: 0,
    width: '100%',
    minHeight: 100,
    maxHeight: 400,
    bottom: 0,
    zIndex: 4,
    position: 'absolute',
    background: '#f0f0f0',
  },
  table: {
    width: 'fit-content',
    margin: '0px auto 30px',
    padding: '10px 10px 0',
    color: '#000',
    '& th': {
      backgroundColor: '#fff',
    },
    '& td': {
      textAlign: 'center',
    },
    '& span, input': {
      display: 'block',
      padding: '8px 12px',
      marginRight: '18px',
      maxWidth: '150px',
      textAlign: 'center',
      overflowX: 'auto',
      border: '1px solid transparent',
      fontSize: '12px',
    },
    '& input': {
      outline: 'none',
    },
  },
  header: {
    position: 'relative',
    '& input': {
      marginRight: '22px',
    },
    '& span': {
      marginLeft: '12px',
    },
    '&:hover': {
      '& $editButton': {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
      },
    },
  },
  colHeader: {
    '&.selected': {
      '& span, & input': {
        color: '#4169e1',
      },
    },
  },
  rowHeader: {
    '& input': {
      marginLeft: '12px',
    },
  },
  row: {
    '& input': {
      marginRight: '0',
    },
    '& span': {
      marginRight: '0',
      '&:hover': {
        border: '1px solid #4169e1',
      },
    },
  },
  colorPicker: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 12,
    height: '100%',
    cursor: 'pointer',
  },
  editButton: {
    padding: '6px 7px',
    position: 'absolute',
    top: 0,
    right: 0,
    backgroundColor: '#f0f0f0',
    cursor: 'pointer',
    display: 'none',
    '& svg': {
      width: 3,
    },
  },
  toolBar: {
    background: '#fff',
    border: '1px solid #eee',
    padding: '3.6px 7.2px',
    position: 'relative',
    '& h3': {
      color: '#555',
      fontSize: '12px',
      letterSpacing: '.1px',
      margin: 0,
      textTransform: 'uppercase',
    },
  },
  resizeButton: {
    color: '#555',
    cursor: 'ns-resize',
    fontWeight: 700,
    left: '50%',
    padding: '3.6px 7.2px',
    position: 'absolute',
    top: '30%',
    transform: 'translate(-50%,-50%)',
    fontSize: '18px',
    userSelect: 'none',
  },
  closeButton: {
    color: '#555',
    cursor: 'pointer',
    fontSize: '24px',
    position: 'absolute',
    right: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  input: {
    marginRight: '0px!important',
    border: '1px solid #4169e1!important',
  },
  dropdownOpen: {
    border: '1px solid #4169e1!important',
  },
  dropdown: {
    '& .ant-dropdown-menu': {
      padding: '0!important',
      border: '1px solid #ccc',
      borderRadius: '4px',
      boxShadow: '0 1px 1px #0000001a',
    },
    '& .ant-dropdown-menu-item': {
      padding: '0px!important',
      '& span': {
        padding: '4px 8px',
        fontSize: 12,
        display: 'block',
        whiteSpace: 'nowrap',
      },
    },
    '& .ant-dropdown-menu-item:hover': {
      '& span': {
        backgroundColor: '#006CE5',
        color: '#fff',
      },
    },
    '& .ant-dropdown-menu-title-content': {
      padding: '0!important',
    },
  },
});
